import { FC, useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { MaterialIcon } from './material_icon';
import './device_navbar.css';
import { MenuItem } from './menu';
import { useUserContext } from '../../contexts/user_context';
import { useAppContext } from '../../contexts/app_context';
import { UserInfoComponent } from '../user_info_component';
import { Link } from 'react-router-dom';
import { PoweredBy } from '../powered_by';

interface Props {
    items: MenuItem[];
}

export const DeviceNavbar: FC<Props> = ({ items }) => {
    const [is_open, set_is_open] = useState<boolean>(false);
    const location = useLocation();
    const { open_login_dialog, open_register_dialog } = useAppContext();
    const { access_token, spins, logout } = useUserContext();
    const navigate = useNavigate();

    const get_badge = useCallback(
        (badge: string) => {
            switch (badge) {
                case 'spins':
                    return access_token ? <span className='badge bounce sm'>Spins: {spins}</span> : null;
                default:
                    return null;
            }
        },
        [access_token, spins]
    );

    useEffect(() => {
        document.body.style.overflow = is_open ? 'hidden' : 'initial';
    }, [is_open]);

    return (
        <div className='device-navbar'>
            <div className='nav-container' data-is-open={Number(is_open)}>
                <div className='nav-content'>
                    <UserInfoComponent />
                    <nav>
                        {items.map(({ path, label, icon, badge }, index) => (
                            <button
                                key={index}
                                data-is-active={String(Number(location.pathname === path))}
                                onClick={() => {
                                    set_is_open(false);
                                    navigate(path);
                                }}
                            >
                                <MaterialIcon size='24px' icon={icon} />
                                <span>{label}</span>
                                {badge && get_badge(badge)}
                            </button>
                        ))}
                    </nav>
                    {access_token ? (
                        <button className='logout-button' onClick={logout}>
                            Logout
                        </button>
                    ) : (
                        <div className='sign-up-buttons'>
                            <button className='login-button' onClick={open_login_dialog}>
                                Login
                            </button>
                            <button className='primary-button register-button' onClick={open_register_dialog}>
                                Register
                            </button>
                        </div>
                    )}
                    <PoweredBy/>
                </div>
            </div>
            <button className='nav-button' onClick={() => set_is_open((s) => !s)} data-is-open={Number(is_open)}>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </button>
            <Link className='logo' to='/'>
                <img src='/assets/logo.png' alt='' />
            </Link>{' '}
        </div>
    );
};
